import React from "react";
import { ProtectedPageWrapper } from "../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { SupportListingView } from "./_components/SupportListingView";

export function SupportPage(): JSX.Element  {

    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']}>
            <SupportListingView />
        </ProtectedPageWrapper>
    );
}